var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payments-container delivery-timeline"},[_c('payment-methods'),(_vm.processInProgress(_vm.process))?_c('progress-bar',{staticClass:"w92",attrs:{"btn-large":true,"uiBlock":true}}):_c('div',{staticClass:"checkout-buttons"},[_c('button',{staticClass:"btn btn-solid btn-block",class:{ disabled: _vm.btnDisabled },on:{"click":function($event){return _vm.checkout()}}},[_vm._v("\n      "+_vm._s(_vm._T('Place Order'))+"\n    ")]),_c('router-link',{staticClass:"btn btn-outline btn-block",attrs:{"to":{
        name: _vm.brandStoreRoute('store_page'),
        params: {
          ..._vm.brandStoreParams,
        },
      }}},[_vm._v(_vm._s(_vm._T('Continue shopping')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }